import request from 'api/request';

export default function inviteUsersByEmail({ courseId, roster, role }) {
  return request({
    url: `/courses/${courseId}/invitations`,
    method: 'POST',
    data: { roster, role },
  });
}
